import { MeshType } from "~/src/utils/shape-type";
import * as THREE from "three";

export const ShapeSelectorCanvasConfig = {
    RenderConfig: {
        width: 300,
        height: 200,
        cameraPositionZ: 45,
    },
    cameraConfig: {
        fov: 20, // filed of view
    },
    transparentOpacity: 0.3,
    solidOpacity: 1,
    lookAtOffset: new THREE.Vector3(-20, -20, 80),
    selectionHightlight: {
        color: 0xffb703,
        opacity: 0.7,
        transparent: true,
        side: THREE.BackSide,
    },
};

export const AnimationConfig = {
    rotation: {
        x: 0.5,
        y: 0.5,
        z: 0.5,
    },
};

export interface ShapeJson {
    object: {
        name: MeshType;
        userData: {
            faceMesh: THREE.Mesh;
        };
    };
}

export enum FaceChoice {
    singleFace = "singleFace",
    fullface = "fullFaces",
}

export const SmallScreenCanvasConfig = {
    RenderConfig: {
        width: 150, // Adjusted for smaller screen
        height: 100, // Adjusted for smaller screen
        cameraPositionZ: 10, // Closer camera for smaller screen
    },
    cameraConfig: {
        fov: 60, // Wider field of view for smaller screens
    },
    transparentOpacity: 0.3,
    solidOpacity: 1,
    gridSize: 250, // Reduced grid size for smaller screen
    cellSize: 10, // Smaller cell size for more detail
};

export const SmallScreenAnimationConfig = {
    rotation: {
        x: 0.005, // Slower rotation for smaller screens
        y: 0.005,
        z: 0.005,
    },
};
